<template>
  <!-- SAMPLE USAGE -->
  <!--
  <v-form ref="testform">
    <date-picker
      required (For the validation)
      icon="mdi-calendar"
      label="Select a date"
      v-model="dateVariable"
      writable (writable input)
      format="DD-MM-YYYY" (Just for appereance to the user)
      min="2019-09-10"
      max="2019-10-08"
    ></date-picker>
  </v-form>
  -->
  <v-menu
    absolute
    v-model="open"
    ref="open"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        v-on="on"
        :placeholder="format"
        :prepend-icon="icon"
        v-mask="formatForMask"
        :readonly="!writable"
        @input="updateFromInput"
        :required="required"
        :rules="[v => validateAll(v)]"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title @input="open = false" :max="max" :min="min">
      <v-btn text color="primary" @click="open = false">Cancel</v-btn>
    </v-date-picker>
    <!-- Returns YYYY-MM-DD -->
  </v-menu>
</template>

<script>
import moment from "moment";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    label: {
      required: true,
      type: String
    },
    value: {
      required: false,
      type: [String, Number]
    },
    icon: {
      required: false,
      type: String
    },
    format: {
      required: false,
      type: String,
      default: "DD/MM/YYYY"
    },
    writable: {
      required: false,
      type: Boolean,
      default: false
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    rules: {
      required: false,
      type: Array
    },
    dateRule: {
      required: false,
      type: Boolean
    },
    max: {
      required: false,
      type: String,
      default: null
    },
    min: {
      required: false,
      type: String,
      default: null
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  created() {
    if (moment(this.value).isValid()) {
      this.date = moment(new Date(this.value)).format("YYYY-MM-DD");
    } else {
      this.date = ''
    }
  },
  computed: {
    formatForMask() {
      let formattedMask = this.format;
      formattedMask = formattedMask.replace(new RegExp("D", "g"), "#");
      formattedMask = formattedMask.replace(new RegExp("M", "g"), "#");
      formattedMask = formattedMask.replace(new RegExp("Y", "g"), "#");
      return formattedMask;
    }
  },
  data: () => ({
    date: null,
    dateFormatted: null,
    open: false
  }),
  methods: {
    formatDate(date) {
      if (!date) return null;
      return moment(new Date(date)).format(this.format);
    },
    deFormatDate(date) {
      if (!date) return null;
      return moment(date, this.format).format("YYYY-MM-DD");
    },
    update() {
      this.$emit("input", moment(new Date(this.date)).format("YYYY-MM-DD"));
    },
    updateFromInput() {
      if (this.dateFormatted.length > 10) return null;
      if (
        this.dateFormatted.length == 10 &&
        moment(this.dateFormatted, this.format).isValid()
      ) {
        this.date = this.deFormatDate(this.dateFormatted);
      } else {
        this.$emit("input", "");
      }
    },
    checkMinDate(v) {
      let isMin = true;
      if (this.min) {
        isMin = moment(this.date).diff(this.min) >= 0;
      }
      return isMin;
    },
    checkMaxDate(v) {
      let isMax = true;
      if (this.max) {
        isMax = moment(this.date).diff(this.max) <= 0;
      }
      return isMax;
    },
    isMinMaxValid() {
      let isMin = true;
      let isMax = true;
      if (this.min) {
        isMin = moment(this.date).diff(this.min) >= 0;
      }
      if (this.max) {
        isMax = moment(this.date).diff(this.max) <= 0;
      }
      return isMin && isMax;
    },
    dateValidation(date) {

      date = moment(date , "DD/MM/YYYY").format("YYYY-MM-DD")
      if (date === null) return false;
      if (!this.required) return true;
      const isValid = moment(date, "YYYY-MM-DD").isValid();
      if (isValid && this.dateFormatted.length >= 10 && moment(this.min , "YYYY-MM-DD").isSameOrBefore(moment(date)) && moment(this.max, "YYYY-MM-DD").isSameOrAfter(moment(date))) {
        return true;
      } else return false;
    },
    validateAll(v) {
      if (this.dateRule) {
        const dateValidationBool = this.dateValidation(v)
        if (!dateValidationBool) return "Please pick a valid date"
      }
      console.log("validate", v , this.dateRule)
      // if (!this.dateValidation(v)) return "Please pick a valid date";
      // if (!this.checkMinDate(v)) return "Selected date is not valid";
      // if (!this.checkMaxDate(v)) return "Selected date is not validasd";
      return true;
    }
  },
  watch: {
    date() {
      if(this.date != '') {
        this.dateFormatted = this.formatDate(this.date);
      } else {
        this.dateFormatted = '';
      }
      this.update();
    },
    value() {
      if (moment(this.value).isValid()) {
        this.date = moment(new Date(this.value)).format("YYYY-MM-DD");
      } else {
        this.date = '';
      }
    }
  }
};
</script>